import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=53c85038&"
import script from "./Preference.vue?vue&type=script&lang=js&"
export * from "./Preference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports